export default __webpack_public_path__ + "static/media/link_icon.52befaac.svg";